import React from 'react';
import {Routes} from 'react-router-dom';
import {useSelector} from 'react-redux';

import {isFetchMeErrorSelector, getProtectedRoute} from 'entities/user';

import Error from './ui/Error/Error';
import {routes} from './routes';


const Router = () => {
    const isFetchMeError = useSelector(isFetchMeErrorSelector);

    if (isFetchMeError) {
        return <Error/>;
    }

    return (
        <Routes>
            {
                routes.map(routeProps => getProtectedRoute(routeProps))
            }
        </Routes>
    );
};

export default Router;
